export default __webpack_public_path__ + "static/media/13851.controlling-tour-committee.photo.7ec8e80d.jpeg";